import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Autoplay } from "swiper";

const style = {
	polWrapper: `py-4 flex items-center justify-center lg:basis-1/2`,
	slider: `w-[240px] h-[320px] md:w-[350px] md:h-[450px] xl:w-[500px] xl:h-[650px]`,
	slide: `flex items-center justify-center`,
	polaImg: `block w-full h-full object-cover`,
};

const Polaroid = () => {
	return (
		<div className={style.polWrapper}>
			<Swiper
				className={style.slider}
				loop
				cardsEffect={{
					slideShadows: false,
				}}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false,
				}}
				speed={1000}
				effect='cards'
				grabCursor={true}
				modules={[EffectCards, Autoplay]}
			>
				<SwiperSlide className={style.slide}>
					<img
						className={style.polaImg}
						src='./images/polaroid/polw-1.webp'
						alt='pola-one'
					/>
				</SwiperSlide>
				<SwiperSlide className={style.slide}>
					<img
						className={style.polaImg}
						src='./images/polaroid/polw-2.webp'
						alt='pola-two'
					/>
				</SwiperSlide>
				<SwiperSlide className={style.slide}>
					<img
						className={style.polaImg}
						src='./images/polaroid/polw-3.webp'
						alt='pola-three'
					/>
				</SwiperSlide>
				<SwiperSlide className={style.slide}>
					<img
						className={style.polaImg}
						src='./images/polaroid/polw-4.webp'
						alt='pola-four'
					/>
				</SwiperSlide>
				<SwiperSlide className={style.slide}>
					<img
						className={style.polaImg}
						src='./images/polaroid/polw-5.webp'
						alt='pola-five'
					/>
				</SwiperSlide>
			</Swiper>
		</div>
	);
};

export default Polaroid;
